import { useTranslation } from 'react-i18next';
import { useVeriff } from '@/hooks/shared/useVeriff';
import s from './index.module.scss';

const parentId = 'veriff-root';

export const VeriffButton = ({ user, onSuccess, onClose }) => {
  const { t } = useTranslation();

  const submitText = t('modal:country_verification_modal.continue');

  useVeriff({
    parentId,
    user,
    submitText,
    onSuccess,
    onClose,
  });

  return <div id={parentId} className={s.veriff} />;
};